import Avatar, { type AvatarProps } from "@mui/material/Avatar";
import { styled } from "../../../../lib/styled";

/** The theme colours an avatar can take. */
export type ColoredAvatarColor = "primary" | "secondary" | "success" | "info" | "warning" | "error";

const TintedAvatar = styled(Avatar)<{ $color: ColoredAvatarColor }>(({ theme, $color }) => ({
  backgroundColor: theme.tints[$color].background,
  color: theme.tints[$color].color,
  // Initials sit comfortably inside the tile instead of filling it.
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: "0.02em",
}));

export interface ColoredAvatarProps extends Omit<AvatarProps, "color"> {
  /** The theme colour whose tint is the background and whose dark shade the text. */
  color?: ColoredAvatarColor;
}

/** An `Avatar` drawn in one of the theme's colours, a rounded square unless told otherwise (it
 *  stands for a thing, not a person); everything else passes through to `Avatar`. */
export function ColoredAvatar({
  color = "primary",
  variant = "rounded",
  ...avatarProps
}: ColoredAvatarProps) {
  return <TintedAvatar $color={color} variant={variant} {...avatarProps} />;
}
